import { Autocomplete, Button, patch, Stack, TextField } from '@mui/material';
import GlobalTableGenerator from '../../../../components/GlobalTableGenerator';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getPlacementTrackerCourses,
  getPlacementTrackerCoursesTable,
  patchPlacementTrackerCourses,
} from '../../../../redux/features/generalSlice';
import { useSelector } from 'react-redux';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';

export default function ChooseCourse() {
  const placementTrackerCourse = useSelector((state) => state.general.placementTrackerCourses.data);
  const submitLoading = useSelector((state) => state.general.submitLoading);
  const placementTrackerCourseLoading = useSelector((state) => state.general.placementTrackerCourses.loading);
  const placementTrackerCourseTable = useSelector((state) => state.general.placementTrackerCoursesTable.data);
  const placementTrackerCourseTableLoading = useSelector((state) => state.general.placementTrackerCoursesTable.loading);
  const [courseId, setCourseId] = useState({ course_available_id: '', course_name: '' });
  const [refresh, setRefresh] = useState(false);

  const apiHelper = useHandleApiResponse();

  const column = [
    {
      field: 'course_name',
      headerName: 'Course Name',
      width: 300,
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 150,
      renderCell: ({ row }) => (
        <Button variant="outlined" color="error" onClick={() => submitHandler(0, row?.course_available_id)}>
          Delete
        </Button>
      ),
    },
  ];

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPlacementTrackerCourses());
  }, []);

  useEffect(() => {
    dispatch(getPlacementTrackerCoursesTable(1));
  }, [refresh, dispatch]);

  const submitHandler = (status, course_available_id) => {
    const data = {
      course_available_id: course_available_id ?? courseId?.course_available_id,
      status,
    };
    dispatch(patchPlacementTrackerCourses(data)).then((res) =>
      apiHelper(res, {
        onSuccess: () => {
          setRefresh((prev) => !prev);
        },
      }),
    );
  };

  return (
    <Stack gap={2}>
      <Stack direction={'row'} gap={1}>
        <Autocomplete
          fullWidth
          options={placementTrackerCourse}
          onChange={(_, v) => setCourseId(v)}
          renderOption={(prop, option) => (
            <li key={option?.course_available_id} {...prop}>
              {option?.course_name}
            </li>
          )}
          getOptionLabel={(option) => option?.course_name || ''}
          isOptionEqualToValue={(opt, val) => opt?.course_available_id === val?.course_available_id}
          renderInput={(params) => <TextField {...params} label="Add to Placement" />}
          loading={placementTrackerCourseLoading}
        />
        <Button variant="contained" disabled={!Boolean(courseId) || submitLoading} onClick={() => submitHandler(1)}>
          {submitLoading ? 'Adding' : 'Add'}
        </Button>
      </Stack>

      <GlobalTableGenerator
        pagination
        searchOption
        searchBy={['course_name']}
        columns={column}
        loading={placementTrackerCourseTableLoading}
        rows={placementTrackerCourseTable}
        TableContainerStyle={{
          // minHeight: { xs: '100%', sm: height },
          border: '1px solid #c9c6c6ff',
          borderRadius: 1,
          borderCollapse: 'collapse',
          '& .MuiTableCell-root': {
            border: '1px solid #d9d9d9',
          },
        }}
        TableHeadStyle={{
          bgcolor: '#3a79bb',
          '& .MuiTableCell-root': {
            color: '#fff',
            fontWeight: 600,
          },
        }}
      />
    </Stack>
  );
}
